import * as React from 'react';

import {Button} from 'shells/button/button';
import {ButtonMover} from 'shells/button-mover/button-mover';
import {EntityPill} from 'shells/entity-pill/entity-pill';

import type {GetContactAudienceMemberships_contact_audienceMembershipsUnsubscribed as UnsubscribedAudiences} from 'nutshell-graphql-types';

import styles from './audience-info.module.css';

type Props = {
    unsubscribedMemberships: UnsubscribedAudiences[];
    onRemove: (membershipId: string) => void;
};

export function ContactUnsubscribedAudiences(props: Props) {
    const [showUnsubscribedAudiences, setShowUnsubscribedAudiences] =
        React.useState<boolean>(false);

    const {unsubscribedMemberships} = props;

    return (
        <>
            {props.unsubscribedMemberships.length ? (
                <ButtonMover direction='left' size='normal'>
                    <Button
                        variant='text-secondary'
                        onClick={() => {
                            setShowUnsubscribedAudiences(!showUnsubscribedAudiences);
                        }}
                    >
                        <i>
                            {showUnsubscribedAudiences
                                ? 'Hide unsubscribed audiences'
                                : `+${unsubscribedMemberships.length} unsubscribed ${
                                      unsubscribedMemberships.length > 1 ? 'audiences' : 'audience'
                                  }`}
                        </i>
                    </Button>
                </ButtonMover>
            ) : undefined}
            {showUnsubscribedAudiences ? (
                <div>
                    {unsubscribedMemberships.map((membership) => {
                        return (
                            <EntityPill
                                key={membership.id}
                                isSmall={true}
                                name={
                                    <div className={styles['unsubscribed-pill-label']}>
                                        <i>{membership.audience.name}</i>
                                    </div>
                                }
                                type='light'
                                onRemove={() => props.onRemove(membership.id)}
                                removeButtonTooltip='Remove from audience'
                            />
                        );
                    })}
                </div>
            ) : undefined}
        </>
    );
}
